import { Component, Input, ViewEncapsulation } from '@angular/core';
import { HubPlaceAdditionalData } from '../../../models/hub/hub.google.place.data';
import { BaseComponent } from '../../../common/components/base.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { EventTimeService } from '../../../services/event.time.service';
import { isNullOrUndefined } from '../../../common/extensions';

@Component({
    selector: 'ig-visitor-place-opening-hours',
    templateUrl: './place.opening.hours.component.html',
    styleUrls: ['./place.opening.hours.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class VisitorPlaceOpeningHoursComponent extends BaseComponent {
    @Input() public googlePlaceAdditionalData: HubPlaceAdditionalData;
    @Input() public hours: any;
    @Input() public hoursText: any;

    constructor() {
        super();
    }

    ngOnInit() {
        if (this.isMobile) {
            this.useShortWeekdays();
        }

        try {
            this.getIsOpenNow();
        } catch (e) {
            console.log(e);
        }
    }

    useShortWeekdays() {
        this.googlePlaceAdditionalData.opening_hours.weekday_text =
            this.googlePlaceAdditionalData.opening_hours.weekday_text.map((x) => {
                let seg = x.split(': ');
                return `${seg[0].substr(0, 3)}: ${seg[1]}`;
            });
    }

    getIsOpenNow() {
        if (
            !this.googlePlaceAdditionalData ||
            !this.googlePlaceAdditionalData.opening_hours ||
            !this.googlePlaceAdditionalData.opening_hours.periods
        )
            return;

        const timezoneFormatterDefault = localStorage.getItem(localStorageKeys.timezoneFormatterDefault);
        let hour;
        if (timezoneFormatterDefault) {
            hour = EventTimeService.getLocalHourByFormatter(new Date(), timezoneFormatterDefault);
        }

        if (isNullOrUndefined(hour)) return;

        const openingHours = this.googlePlaceAdditionalData.opening_hours.periods;

        // open 24 hours everyday
        if (openingHours.length === 1 && openingHours[0].open.day === 0 && openingHours[0].open.time === '0000') {
            this.googlePlaceAdditionalData.opening_hours.open_now = true;
            return;
        }

        const weekdayOfToday = new Date().getDay();
        const weekdayStatuses = openingHours.filter(
            (x) => x.open.day === weekdayOfToday && x.open.time && x.close.time
        );
        if (!weekdayStatuses.length) {
            this.googlePlaceAdditionalData.opening_hours.open_now = false;
        } else {
            for (const status of weekdayStatuses) {
                const open = parseInt(status.open.time, 10) / 100;
                let close = parseInt(status.close.time, 10) / 100;
                close = close === 0 ? 24 : close;

                const isOpen = open <= hour && close > hour;
                if (isOpen) {
                    this.googlePlaceAdditionalData.opening_hours.open_now = isOpen;
                    return;
                }
            }
            this.googlePlaceAdditionalData.opening_hours.open_now = false;
        }
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/place.opening.hours/place.opening.hours.component.ts